import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@cian/ui-kit';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';

import { selectRequestButtonLoading } from '../../selectors/requestButton';

interface IRequestButtonContainerProps {
  size: TButtonSize;
  theme?: TButtonTheme;
  'data-testid'?: string;
  onClick: () => void;
}

export const RequestButtonContainer: React.FC<IRequestButtonContainerProps> = ({
  size,
  theme = 'fill_white_primary',
  'data-testid': dataTestId,
  onClick,
}) => {
  const isLoading = useSelector(selectRequestButtonLoading);

  return (
    <Button size={size} fullWidth theme={theme} onClick={onClick} data-testid={dataTestId} loading={isLoading}>
      Оставить заявку
    </Button>
  );
};
